import '@/app/app.css';
import './contacts.css';

import '@/app/app';

import { initYmaps } from '@/shared/common/ymap/ymap';
import { OfficeVideo } from '@/components/block/office-video/office-video';

document.addEventListener('DOMContentLoaded', () => {
	const officeVideo = document.querySelector('.js-office-video');

	initYmaps();
	officeVideo && new OfficeVideo(officeVideo);
});
